import React from "react";

const Copyright = () => {
	return (
		<div class="copyright">
			<p class="attribution">
				<i class="ri-copyright-line ri-2x"></i>
				<span>
					Challenge by
					<a
						href="https://www.frontendmentor.io?ref=challenge"
						target="_blank"
						rel="noreferrer"
					>
						&nbsp;Frontend Mentor&nbsp;
					</a>
					Coded by <a href="https://github.com/HatimHJ">&nbsp;hatimHJ&nbsp;</a>
				</span>
			</p>
		</div>
	);
};

export default Copyright;
